<template>
	<div class="page" :style="[pageDiv]">
		<!-- <Tip :tip="tip" /> -->
		<div class="from_div" :style="[fromDiv]">
			<el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="110px">
				<el-form-item label="创建账号：" v-if="type == 1">
					{{form.created_by.nick_name}} {{form.created_by.phone}}
				</el-form-item>
				<el-form-item label="册集名称：" prop="catalogue_name">
					<el-input class="input long-input" v-model="form.catalogue_name" placeholder="请输入内容"></el-input>
				</el-form-item>
				<el-form-item label="报价商品：" prop="catalogue_goods">
					<div class="row" style="margin-bottom: 20px;">
						<span class="span_">已关联 {{form.catalogue_goods.length}} 种商品</span>
						<el-button class="item_btn" style="margin-left: 20px;" size="mini" type="success"
							@click="open()">关联商品</el-button>
					</div>
					<el-table class="table_div" :data="form.catalogue_goods" :header-cell-style="tabStyle" :span-method0="objectSpanMethod">
						<el-table-column label="排序" width="120" align="center" style="border: 1px solid red;">
							<template slot-scope="scope">
								<el-input class="input" style="width: 100px;" v-model="scope.row.sort" placeholder="请输入"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="商品ID/名称" width="200">
							<template slot-scope="scope">
								<span>{{scope.row.good_id}} / {{scope.row.good_name}}</span>
							</template>
						</el-table-column>
						<el-table-column label="规格ID/名称">
							<template slot-scope="scope">
								<span>{{scope.row.sku_id}} / {{scope.row.spec_data_str}}</span>
							</template>
						</el-table-column>
						<el-table-column label="成本价">
							<template slot-scope="scope">
								<span>{{scope.row.cost_price}}</span>
							</template>
						</el-table-column>
						<el-table-column label="划线价">
							<template slot-scope="scope">
								<el-input class="input" v-model="scope.row.crossed_price" placeholder="请输入"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="销售价">
							<template slot-scope="scope">
								<el-input class="input" v-model="scope.row.sale_price" placeholder="请输入"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="备注">
							<template slot-scope="scope">
								<el-input class="input" v-model="scope.row.remark" placeholder="请输入"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="100">
							<template slot-scope="scope">
								<el-button class="item_btn" size="mini" type="danger"
									@click="delSku(scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-form-item>
				<el-form-item label="封面图案：" prop="catalogue_coverimg">
					<div class="col">
						<span>尺寸：210-297mm 印刷分辨率：不低于300dpi 格式：JPG</span>
						<el-radio-group v-model="form.catalogue_cover_style">
							<div class="row">
								<div v-for="(citem, cindex) in coverimgs" :key="cindex" class="col"
									style="align-items: center;margin-right: 10px;">
									<div class="upload_div">
										<img :src="citem.url" class="img">
									</div>
									<el-radio :label="cindex">{{citem.title}}</el-radio>
								</div>
								<div class="col" style="align-items: center;">
									<multiUpload :type='0' :limitImg='1' :noneBtnImg='coverImgList.length > 0'
										:fileList="coverImgList" @saveImg="saveImg" @delImg="delImg" />
									<el-radio :label="-1">自定义上传</el-radio>
								</div>
							</div>
						</el-radio-group>
					</div>
				</el-form-item>
				<el-form-item label="自定义LOGO：" prop="catalogue_logo" style="margin-bottom: -10px">
					<div class="row">
						<multiUpload :type='2' :limitImg='1' :noneBtnImg='logoList.length > 0'
							:fileList="logoList" @saveImg="saveImg" @delImg="delImg" />
						<span class="span_">选填（分辨率不低于300）</span>
					</div>
				</el-form-item>
				<el-form-item label="封面标题：" prop="catalogue_title" style="margin-bottom: 10px">
					<el-input class="input long-input" v-model="form.catalogue_title" placeholder="请输入30字内"></el-input>
				</el-form-item>
				<el-form-item label="公司名称：" prop="catalogue_company" style="margin-bottom: 10px">
					<el-input class="input long-input" v-model="form.catalogue_company"
						placeholder="请输入30字内"></el-input>
				</el-form-item>
				<el-form-item label="报价有效期：" prop="expire_start_end" style="margin-bottom: 10px">
					<el-date-picker class="picker" v-model="form.expire_start_end" type="datetimerange"
						value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期" placeholder="请选择时间范围" />
				</el-form-item>
				<el-divider></el-divider>
				<el-form-item label="内页商品排版：">
					<div class="col">
						<span class="span_">A4尺寸，横向排版</span>
						<div class="row">
							<el-radio-group v-model="form.catalogue_style">
								<div class="col" style="align-items: center;margin-right: 20px;">
									<img src="../../../assets/catalogue/catalogue1.png" style="margin-bottom: 10px;" />
									<el-radio label="1">一页一品</el-radio>
								</div>
							</el-radio-group>
							<el-radio-group v-model="form.catalogue_style">
								<div class="col" style="align-items: center;margin-right: 20px;">
									<img src="../../../assets/catalogue/catalogue3.png" style="margin-bottom: 10px;" />
									<el-radio label="2">一页三品</el-radio>
								</div>
							</el-radio-group>
							<el-radio-group v-model="form.catalogue_style">
								<div class="col" style="align-items: center;margin-right: 20px;">
									<img src="../../../assets/catalogue/catalogue8.png" style="margin-bottom: 10px;" />
									<el-radio label="3">一页八品</el-radio>
								</div>
							</el-radio-group>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="内页底图：" prop="catalogue_background">
					<div class="col">
						<span>尺寸：210-297mm 印刷分辨率：不低于300dpi 格式：JPG</span>
						<el-radio-group v-model="form.catalogue_bg_style">
							<div class="row">
								<div v-for="(citem, cindex) in coverimgs" :key="cindex" class="col"
									style="align-items: center;margin-right: 10px;">
									<div class="upload_div">
										<img :src="citem.url" class="img">
									</div>
									<el-radio :label="cindex">{{citem.title}}</el-radio>
								</div>
								<div class="col" style="align-items: center;">
									<multiUpload :type='1' :limitImg='1' :noneBtnImg='backImgList.length > 0'
										:fileList="backImgList" @saveImg="saveImg" @delImg="delImg" />
									<el-radio :label="-1">自定义上传</el-radio>
								</div>
							</div>
						</el-radio-group>
					</div>
					
				</el-form-item>
				<el-divider></el-divider>
				<el-form-item label="封底落款：" prop="catalogue_about_company">
					<div class="row">
						<!-- <div class="col" style="align-items: center;">
							<div class="upload_div">
								<span>上传(300-300px)</span>
							</div>
							<span>LOGO或二维码</span>
						</div> -->
						<div class="col">
							<div class="row" style="margin: 0 0 20px 40px;">
								<span>公司名称：</span>
								<el-input class="input long-input" v-model="form.catalogue_about_company"
									placeholder="请输入内容"></el-input>
							</div>
							<div class="row" style="margin: 0 0 20px 40px;">
								<span>名称英文：</span>
								<el-input class="input long-input" v-model="form.catalogue_about_en"
									placeholder="请输入内容"></el-input>
							</div>
							<div class="row" style="margin: 0 0 20px 40px;">
								<span>公司地址：</span>
								<el-input class="input long-input" v-model="form.catalogue_about_address"
									placeholder="请输入内容"></el-input>
							</div>
							<div class="row" style="margin: 0 0 20px 40px;">
								<span>业务电话：</span>
								<el-input class="input long-input" type="number" maxlength="11" v-model="form.catalogue_about_phone"
									placeholder="请输入内容"></el-input>
							</div>
						</div>
					</div>
				</el-form-item>
			</el-form>
		</div>
		<!--弹出层-->
		<GoodPup :name="goodTable" :show="show" @close="goodClose" @goodList="goodList"
			:type="(typeof(this.type) === 'undefined') ? 0 : -1" />
		<div class="foot_div" :style="[footDiv]">
			<el-button v-if="(typeof(this.type) !== 'undefined')" @click="close">返回</el-button>
			<el-button type="primary" @click="submit('form')">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import GoodPup from "../../../components/GoodPup/GoodPup.vue"
	import multiUpload from "../../../components/multiUpload/multiUpload.vue"
	import {
		catalogueAdd,
		catalogueEdit,
		catalogueDetail,
		catalogueOptions
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip,
			GoodPup,
			multiUpload
		},
		props: {
			type: {
				type: Number
			}
		},
		data() {
			return {
				tip: '制作商品的价格报价册（货盘表）。',
				coverImgList:[],//自定义封面
				logoList:[],//自定义logo
				backImgList:[],//自定义封底
				form: {
					resource: '',
					catalogue_id: 0,
					catalogue_name: '',
					catalogue_goods: [],
					catalogue_cover_style: 0,
					catalogue_coverimg: 'xxx.png',
					catalogue_backimg: '',
					catalogue_logo: 'xxx.png',
					catalogue_bg_style: 0,
					catalogue_background: 'xxx.png',
					catalogue_title: '',
					catalogue_company: '',
					expire_start_end: [],
					catalogue_style: '1',
					catalogue_about_log: 'xxx.png',
					catalogue_about_company: '',
					catalogue_about_en: '',
					catalogue_about_address: '',
					catalogue_about_phone: '',
				},
				coverimgs: [],
				innerbgs: [],
				goodTable: '',
				show: false,
				arr: [],
				rowSpanArr: [],
				position: 0,
				rules: {
					catalogue_name: [{
							required: true,
							message: '请输入册集名称',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 20,
							message: '长度在 1 到 20 个字符',
							trigger: 'blur'
						}
					],
					catalogue_goods: [{
						required: true,
						message: '请选择关联商品',
						trigger: 'blur'
					}],
					catalogue_coverimg: [{
						required: true,
						message: '请选择封面图案',
						trigger: 'blur'
					}],
					catalogue_title: [{
							required: true,
							message: '请输入封面标题',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 30,
							message: '长度在 1 到 30 个字符',
							trigger: 'blur'
						}
					],
					catalogue_company: [{
							required: true,
							message: '请输入公司名称',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 30,
							message: '长度在 1 到 30 个字符',
							trigger: 'blur'
						}
					],
					expire_start_end: [{
						required: true,
						message: '请设置有效期',
						trigger: 'blur'
					}, ],
					catalogue_about_company: [{
							required: true,
							message: '请输入封底落款公司名称',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 30,
							message: '长度在 1 到 30 个字符',
							trigger: 'blur'
						}
					],
					catalogue_about_en: [{
							required: true,
							message: '请输入封底落款公司英文',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 30,
							message: '长度在 1 到 30 个字符',
							trigger: 'blur'
						}
					],
					catalogue_about_address: [{
							required: true,
							message: '请输入封底落款公司地址',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 100,
							message: '长度在 1 到 100 个字符',
							trigger: 'blur'
						}
					],
					catalogue_about_phone: [{
							required: true,
							message: '请输入封底落款业务电话',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 20,
							message: '长度在 1 到 20 个字符',
							trigger: 'blur'
						}
					],
				}
			}
		},
		computed: {
			pageDiv() {
				return {
					'position': typeof(this.type) !== 'undefined' ? 'relative' : ''
				}
			},
			fromDiv() {
				return {
					'overflow': typeof(this.type) !== 'undefined' ? 'scroll' : '',
					'height': typeof(this.type) !== 'undefined' ? '640px' : '',
					'min-height': typeof(this.type) !== 'undefined' ? '100%' : '',
					'padding-bottom': typeof(this.type) !== 'undefined' ? '66px' : '',
				}
			},
			footDiv() {
				return {
					'margin-left': typeof(this.type) !== 'undefined' ? '' : '66px'
				}
			},
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333',
					padding: '0 0'
				}
			}
		},
		mounted() {
			this.getCatalogueOptions();
			if (typeof(this.type) !== 'undefined' && this.type !== -1) {
				// this.title = '编辑';
				this.form.catalogue_id = this.type;
				this.getCatalogueDetail();
			}
		},
		methods: {
			getCatalogueOptions() {
				catalogueOptions().then(res => {
					if (res.code == 0) {
						this.coverimgs = res.data.coverimgs;
						this.innerbgs = res.data.innerbgs;
					}
				}).catch(err => {})
			},

			getCatalogueDetail() {
				catalogueDetail({
					catalogue_id: this.form.catalogue_id
				}).then(res => {
					if (res.code == 0) {
						//自定义封面
						if(res.data.catalogue_coverimg != ''){
							if(res.data.catalogue_cover_style == -1){
								this.coverImgList.push({
									url: res.data.catalogue_coverimg
								})
							}
						}
						//自定义logo
						if(res.data.catalogue_logo != ''){
							this.logoList.push({
								url: res.data.catalogue_logo
							})
						}
						//自定义封底
						if(res.data.catalogue_background != ''){
							if(res.data.catalogue_bg_style == -1){
								this.backImgList.push({
									url: res.data.catalogue_background
								})
							}
						}
						res.data.expire_start_end = [res.data.expire_start, res.data.expire_end];
						this.form = res.data;
					}
				}).catch(err => {})
			},

			open() {
				this.goodTable = 'GoodTable';
				this.show = true
			},

			goodClose() {
				this.show = false
			},
			
			//更新货物明细商品列表
			goodList(list) {
				console.log('goodList', list)
				this.arr = this.arr.concat(list);
				var newArr = Array.from(new Map(this.arr.map(item => [item.sku_id, item]))).map(item => item[1]);
				var filterArr = [];
				newArr.forEach((item, index) => {
					filterArr.push({
						sort: index + 1,
						good_id: item.good_id,
						good_name: item.good_name,
						sku_id: item.sku_id,
						spec_data_str: item.spec_data_str,
						cost_price: item.cost_price,
						crossed_price: item.crossed_price,
						sale_price: item.sale_price,
						remark: '',
					});
				})
				this.form.catalogue_goods = filterArr;
				// this.getRowSpan(this.form.catalogue_goods);
				this.show = false
			},
			delSku(sku) {
				var index = this.form.catalogue_goods.indexOf(sku)
				if (index !== -1) {
					this.form.catalogue_goods.splice(index, 1)
					// this.getRowSpan(this.form.catalogue_goods);
				}
			},
			
			//图片存储
			saveImg(arr){
				switch (arr[1]) {
					case 0:
						//封面图
						this.form.catalogue_coverimg = arr[0];
						break;
					case 1:
						//封底图
						this.form.catalogue_background = arr[0];
						break;
					case 2:
						//LOGO
						this.form.catalogue_logo = arr[0]
						break;
				}
			},
			
			//图片移除
			delImg(arr){
				switch (arr[1]) {
					case 0:
						//封面图
						this.form.catalogue_coverimg = '';
						this.coverImgList = []
						break;
					case 1:
						//封底图
						this.form.catalogue_background = '';
						this.backImgList = []
						break;
					case 2:
						//LOGO
						this.form.catalogue_logo = ''
						this.logoList = []
						break;
				}
			},

			submit(form) {
				// 不是自定义上传时获取封面图案
				if (!this.form.catalogue_coverimg) {
					this.form.catalogue_coverimg = this.coverimgs[this.form.catalogue_cover_style].url;
				}
				// 不是自定义上传时获取内页底图
				if (!this.form.catalogue_background) {
					this.form.catalogue_background = this.innerbgs[this.form.catalogue_bg_style].url;
				}
				this.$refs[form].validate((valid) => {
					if (valid) {
						this.form.expire_start = this.form.expire_start_end[0];
						this.form.expire_end = this.form.expire_start_end[1];
						catalogueEdit(this.form).then(res => {
							if (res.code == 0) {
								if(typeof(this.type) !== 'undefined'){
									this.$emit('close',1)
								}else{
									this.$router.push('/albumCollectList');
								}
								this.$message.success(res.msg);
							}else{
								this.$message.error(res.msg);
							}
						}).catch(err => {})
					} else {
						return false;
					}
				});
			},

			close() {
				this.$emit('close')
			},
			// 获取合并的数组
			getRowSpan(data) {
				this.rowSpanArr = [];
				// 遍历数据
				for (let i = 0; i < data.length; i++) {
					if (i === 0) {
						this.rowSpanArr.push(1);
						this.position = 0
					} else {
						if (data[i].good_id === data[i - 1].good_id) {
							this.rowSpanArr[this.position] += 1;
							// 且将数组添加 0 
							this.rowSpanArr.push(0);
						} else {
							this.rowSpanArr.push(1);
							this.position = i;
						}
					}
				}
			},

			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				// 只合并区域位置
				if (columnIndex === 0) {
					const _row = this.rowSpanArr[rowIndex];
					const _col = _row > 0 ? 1 : 0;
					return {
						rowspan: _row,
						colspan: _col
					}
				}
			}
		}
	}
</script>

<style scoped>
	.page {
		margin-bottom: 66px;
		padding: 20px 20px 0 20px;
		min-height: -webkit-fill-available;
	}

	.img {
		width: 150px;
		height: 150px;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
	}

	.uploadtip {
		width: 100%;
		height: 16px;
		padding-left: 20px;
		color: #000;
	}

	.from_div {
		margin-top: 20px;
		width: 100%;
	}

	.input {
		width: 150px;
		margin-right: 20px;
	}

	.long-input {
		width: 400px;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

	.span {
		font-size: 14px;
		color: var(--theme-color);
	}

	.span_ {
		font-size: 14px;
		color: #606266;
	}

	.upload_div {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 150px;
		height: 150px;
		margin-bottom: 20px;
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
	}

	.upload_div_ {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 60px;
		height: 60px;
		margin-bottom: 10px;
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
		margin-right: 20px;
	}

	.el-icon-plus {
		font-size: 20px;
		font-weight: bolder;
		color: #606266;
	}

	.table_div {
		width: 100%;
	}

	.table_div::before {
		height: 0;
	}

	/* /deep/.el-table .el-table__cell{
		padding: 0 0;
	} */

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}
</style>